import React from 'react';
import { Box, Typography, Container, Grid, Paper } from '@mui/material';
import { 
  Lightbulb as IdeaIcon, 
  Speed as SpeedIcon, 
  Security as SecurityIcon,
  Support as SupportIcon 
} from '@mui/icons-material';
import { wolvesLabsColors } from '../../theme/wolvesLabsTheme';

const About: React.FC = () => {
  const values = [
    {
      icon: <IdeaIcon sx={{ fontSize: 50 }} />,
      title: 'Innovación',
      description: 'Soluciones tecnológicas de vanguardia adaptadas a tus necesidades',
    },
    {
      icon: <SpeedIcon sx={{ fontSize: 50 }} />,
      title: 'Agilidad',
      description: 'Desarrollo rápido y eficiente sin comprometer la calidad',
    },
    {
      icon: <SecurityIcon sx={{ fontSize: 50 }} />,
      title: 'Seguridad',
      description: 'Código seguro y protegido, cumpliendo los más altos estándares',
    },
    {
      icon: <SupportIcon sx={{ fontSize: 50 }} />,
      title: 'Soporte',
      description: 'Acompañamiento continuo en cada etapa de tu proyecto',
    },
  ];

  return (
    <Box
      id="about"
      sx={{
        py: { xs: 8, md: 12 },
        backgroundColor: wolvesLabsColors.light,
      }}
    >
      <Container maxWidth="lg">
        <Box sx={{ textAlign: 'center', mb: 8 }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { xs: '2rem', md: '3rem' },
              fontWeight: 800,
              mb: 2,
              background: wolvesLabsColors.gradients.blue,
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            }}
          >
            Sobre Nosotros
          </Typography>
          <Typography
            variant="h6"
            sx={{
              color: wolvesLabsColors.gray[600],
              maxWidth: '800px',
              mx: 'auto',
              lineHeight: 1.8,
              fontSize: { xs: '1rem', md: '1.2rem' },
            }}
          >
            Somos un equipo de desarrolladores apasionados por crear soluciones 
            tecnológicas que transforman negocios. Con años de experiencia en el mercado, 
            ayudamos a empresas de todos los tamaños a alcanzar sus objetivos digitales.
          </Typography>
        </Box>

        <Grid container spacing={4}>
          {values.map((value, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Paper
                elevation={0}
                sx={{
                  p: 4,
                  height: '100%',
                  textAlign: 'center',
                  borderRadius: 0,
                  backgroundColor: 'white',
                  transition: 'all 0.3s ease',
                  border: '2px solid transparent',
                  '&:hover': {
                    transform: 'translateY(-8px)',
                    boxShadow: '0 12px 30px rgba(0,0,0,0.1)',
                    border: `2px solid ${wolvesLabsColors.tech}`,
                  },
                }}
              >
                <Box
                  sx={{
                    color: wolvesLabsColors.tech,
                    mb: 2,
                    display: 'inline-block',
                  }}
                >
                  {value.icon}
                </Box>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 700,
                    mb: 2,
                    color: wolvesLabsColors.primary,
                  }}
                >
                  {value.title}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: wolvesLabsColors.gray[600],
                    lineHeight: 1.7,
                  }}
                >
                  {value.description}
                </Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default About;

